import OrderTypeEnum from '@/app-core/api/enums/OrderTypeEnum'
import OrderTimeEnum from '@/app-core/api/enums/OrderTimeEnum'
import ServiceTypeEnum from '@/app-core/api/enums/ServiceTypeEnum'

export const App = {
  get Version() {
    // eslint-disable-next-line no-undef
    return `v${APP_VERSION}`
  },

  Theme: {
    get Version() {
      // eslint-disable-next-line no-undef
      return `v${THEME_VERSION}`
    },
    get Default() {
      return import.meta.env.VITE_DEFAULT_THEME
    },
    Active: import.meta.env.VITE_ACTIVE_THEME
  },

  Type: {
    isQRScanApp      : false,
    isMobileApp      : false,
    isSelfOrderingApp: false,
    isSelfCheckoutApp: false,
    QrData           : null
  },

  Config: {
    Marketplace: {
      MaintenanceMode     : false,
      TagsEnabled         : true,
      SelectQrDataRequired: true,
      SelectQrDataPopup   : true,
      CanChangeQrData     : true,
      CanClearQrData      : true,
      CanClearAppType     : false,
      AllowGuestOrders    : true,
      AllowCustomAddresses: false,
      AllowLatLngAddresses: false,
      SupportsDelivery    : false,
      SupportsSelfService : false, //TODO: Add it to the API Config
      SupportsCollection  : true,
      DefaultOrderType    : OrderTypeEnum.COLLECTION,
      ShowOrderTypes      : false,
      MinimumOrderType    : ServiceTypeEnum.GLOBAL,
      DeliveryServiceType : ServiceTypeEnum.GLOBAL,
      SmsServiceType      : ServiceTypeEnum.GLOBAL,
      Location            : {
        Name   : 'Marketplace',
        Country: {
          Name: 'Greece',
          Code: 'GR'
        },
        Logo: {
          Logo        : '',
          LogoDark    : '',
          LazyLogo    : '',
          LazyLogoDark: ''
        },
        Address: {
          Street    : '',
          Telephone : '',
          Telephone2: '',
          Telephone3: '',
          Telephone4: ''
        },
        Lat: 38.0475909,
        Lng: 23.8038763
      },
      ScheduledOrder: {
        Active                  : true,
        StartTime               : 10,
        EndTime                 : 24,
        MinimumOrderMinutesAhead: 30
      },
      Currency: {
        name  : 'EUR',
        locale: 'el-GR'
      },
      ActiveLocales: ['el', 'en'],
      DefaultLocale: 'el'
    },
    Log: {
      Active : false,
      Bugsnag: {
        Active: false,
        Env   : ['production'],
        Key   : ''
      },
      LogRocket: {
        Active: false,
        Env   : ['production'],
        Key   : ''
      }
    },
    Analytics: {
      Google: {
        Active  : false,
        GfpId   : '',
        ClientId: ''
      }
    },
    Notifications: {
      OneSignal: {
        AppId : '',
        Active: false,
        Push  : {
          Active: false,
          Web   : {
            Active: true
          },
          Mobile: {
            Active: true
          }
        },
        Sms: {
          Active: false
        },
        Email: {
          Active: false
        }
      }
    },
    Maps: {
      InteractiveMapsProvider: {
        Name: 'mapbox',
        Key : 'pk.eyJ1Ijoib3RvZGV2IiwiYSI6ImNsdWg4dXg0cTB1d3Uya29jNHFsZmJ6M2IifQ.nEJzl5DzYUNDGsvY5rFcrw'
      },
      StaticMapsProvider: {
        Name: 'mapbox',
        Key : 'pk.eyJ1Ijoib3RvZGV2IiwiYSI6ImNsdWg4dXg0cTB1d3Uya29jNHFsZmJ6M2IifQ.nEJzl5DzYUNDGsvY5rFcrw'
      },
      GeocodeProvider: {
        Name: 'google',
        Key : 'AIzaSyBazS0Sqv0Ys9F5oJaQzpIi8sz3EJNttWc'
      }
    },
    Toolbar: {
      AppToolbarExtended: false,
      ShowRegisterButton: false
    },
    Theme: {
      Dark            : false,
      ToggleDarkButton: true
    },
    Cart: {
      /*
      * TODO Respect 'AllowMultistoreOrder' in cart.
      * Maybe show a list of carts to choose from or just
      * show each store cart when in their page. Otherwise
      * allow items from multiple stores.
      */
      AllowMultistoreOrder: true,
      GroupByStore        : true,
      GroupShowStoreLogo  : true,
      ProductShowStoreLogo: false,
      CouponsEnabled      : true
    },
    Checkout: {
      SelectedProductsExpanded: false
    },
    StoreClosed: {
      HideStore           : false,
      DisableStore        : false,
      DisableProducts     : false,
      DisableProductDialog: false,
      DisableAddToCart    : true
    },
    Auth: {
      Email   : true,
      Facebook: true,
      Google  : true,
      Otp     : {
        Email: false,
        Sms  : true
      },
      Providers: {
        facebook: {
          url        : '/auth/facebook',
          redirectUri: 'https://marketplace.dev.getfood.gr/auth/callback',
          clientId   : '1927931864143671'
        },
        google: {
          url        : '/auth/google',
          redirectUri: 'https://marketplace.dev.getfood.gr/auth/callback',
          clientId   : '940670880302-8fv61dhoquurj35j1n9bsot9cmd0cfup.apps.googleusercontent.com'
        }
      }
    }
  },

  Cart: {
    Items   : [],
    Stores  : [],
    Totals  : [],
    Messages: [],
    Status  : {
      IsLoading       : false,
      CouponLoading   : false,
      ChargeLoading   : false,
      ScheduledLoading: false,
      OrderTypeLoading: false,
      CouponValue     : ''
    },
    CartTotal       : 0,
    OrderTotal      : 0,
    TotalItems      : 0,
    TotalStores     : 0,
    MinimumOrderDiff: 0,
    OrderType       : OrderTypeEnum.COLLECTION,
    ScheduledOrder  : {
      Type    : OrderTimeEnum.NOW,
      Date    : null,
      Time    : null,
      DateTime: null
    },
    PaymentMethod: null
  },

  Tags: [],

  Stores: [],

  Categories: [],

  Payments: [],

  QrItems: [],

  Services: []
}
